import createCache from "@emotion/cache";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import { Button, createTheme } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import AutoCompleteSingleSearch from "../../../components/dropdown/AutoCompleteSingleSearch";
import ModalCancel from "../../../components/modals/ModalCancel";
import CustomizeSwitch from "../../../components/switch/customizeSwitch";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import TextFieldBadge from "../../../components/textField/TextFeildBadge";
import WebsiteInput from "../../../components/textField/WebsiteInput";
import { BRANCHID, CACHEROUTE, STOREID } from "../../../config/cacheKey";
import {
  getBreanchResponse,
  IBranchRequest,
} from "../../../models/branch.model";
import { ApiResultModel } from "../../../models/common.model";
import { IDropdownResponse } from "../../../models/dropdown.model";
import {
  BranchAdd,
  BranchDelete,
  BranchUpdate,
  GetBranch,
} from "../../../services/branch.service";
import {
  GetAllIbanNumbers,
  GetAllStores,
  GetCities,
} from "../../../services/dropdown.service";
import MapPint from "../../map/mapPoint";
import BranchRegisterSkeleton from "./branchRegisterSkeleton";
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function BranchRegister() {
  const branchId = localStorage.getItem(BRANCHID)!;

  return (
    <DivisionCmp
      title={branchId ? "ویرایش شعبه" : "ثبت شعبه جدید"}
      child={<FormData branchId={branchId} />}
    />
  );
}

const FormData = ({ branchId }: { branchId: string }) => {
  // const storeIdCache = Number(localStorage.getItem(STOREID));
  const [storeIdCache, setStoreIdCache] = useState(
    Number(localStorage.getItem(STOREID))
  );

  const [selectedValue, setSelectedValue] = useState("Onsite");
  const [branchName, setBranchName] = useState("");
  const [address, setAddress] = useState("");
  const [siteAddress, setSiteAddress] = useState("");
  const [sortIndex, setSortIndex] = useState<number | undefined | string>("");
  const [cityIds, setCityIds] = useState<number | undefined>(undefined);
  const [city, setCity] = useState<string>("");
  const [cities, setCities] = useState<IDropdownResponse[]>([]);
  const [ibans, setIbans] = useState<IDropdownResponse[]>([]);
  const [ibanIds, setIbanIds] = useState<number | undefined>(undefined);
  const [iban, setIban] = useState<string>("");
  const [stores, setStores] = useState<IDropdownResponse[]>([]);
  const [storeIds, setStoreIds] = useState<number | undefined>(storeIdCache);
  const [store, setStore] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<any>();
  const [phoneNumbers, setPhoneNumbers] = useState<string[]>([]);
  const [branchIsActive, setBranchIsAvitve] = useState(true);
  const [skelton, setSkelton] = useState(true);
  const [mapPoint, setMapPoint] = useState<any>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const history = useHistory();
  const cacheRoute = localStorage.getItem(CACHEROUTE);
  const backUrl =
    cacheRoute && cacheRoute == "branch"
      ? cacheRoute
      : history.location.pathname.split("/")[1];

  const { mutate: getBranchMutate, isLoading } = useMutation(GetBranch, {
    onSuccess: (data: ApiResultModel<getBreanchResponse>) => {
      setSelectedValue(data.data.type);
      setBranchName(data.data.title);
      setAddress(data.data.address);
      setSiteAddress(data.data.url);
      setSortIndex(data.data.sortIndex);
      setCityIds(data.data.cityId);
      setIbanIds(data.data.ibanId);
      setStoreIds(data.data.storeId);
      setStoreIdCache(data.data.storeId);
      setPhoneNumbers(data.data.phoneNumbers);
      setBranchIsAvitve(data.data.isActive);
      setMapPoint([data.data.lat, data.data.lng]);
    },
  });
  useEffect(() => {
    setTimeout(() => {
      setSkelton(false);
    }, 1000);
    GetAllIbanNumbersMutate({ title: "" });
    GetAllStoresMutate({ title: "" });
    GetCitiesMutate({ title: "" });
    setStoreIds(storeIdCache);
    if (branchId) {
      getBranchMutate({ id: Number(branchId) });
    }
  }, []);

  const handleChangeRadioBtn = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
  };
  //dropdown servises
  const { mutate: GetAllStoresMutate } = useMutation(GetAllStores, {
    onSuccess: (data: ApiResultModel<IDropdownResponse[]>) => {
      if (data) {
        setStores(data.data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetAllIbanNumbersMutate } = useMutation(GetAllIbanNumbers, {
    onSuccess: (data: ApiResultModel<IDropdownResponse[]>) => {
      if (data) {
        setIbans(data.data);
      }
    },
    onError: () => {},
  });
  const { mutate: GetCitiesMutate } = useMutation(GetCities, {
    onSuccess: (data: ApiResultModel<IDropdownResponse[]>) => {
      if (data) {
        setCities(data.data);
      }
    },
    onError: () => {},
  });

  // end dropdown servises
  //srvices update and delete
  const { mutate: BranchAddMutate } = useMutation(BranchAdd, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess) {
        toast.success("عملیات با موفقیت انجام شد");
        if (backUrl === "store") {
          history.push("/store/StoreDetail");
        } else {
          history.push("/store/BranchesTable");
        }
      }
    },
    onError: () => {},
  });
  const { mutate: BranchUpdateMutate } = useMutation(BranchUpdate, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess) {
        toast.success("عملیات با موفقیت انجام شد");
        if (backUrl === "store") {
          history.push("/store/StoreDetail");
        } else {
          history.push("/store/BranchesTable");
        }
      }
    },
    onError: () => {},
  });
  const { mutate: BranchDeleteMutate } = useMutation(BranchDelete, {
    onSuccess: (data: ApiResultModel<boolean>) => {
      if (data.isSuccess) {
        toast.success("عملیات حذف شعبه انجام شد");
        if (backUrl === "store") {
          history.push("/store/StoreDetail");
        } else {
          history.push("/store/BranchesTable");
        }
        setOpenModal(false);
      }
    },
    onError: () => {},
  });
  // end srvices update and delete

  const changeBranchName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setBranchName(event.target.value);
  };
  const changeAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAddress(event.target.value);
  };
  const changeSiteAddress = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSiteAddress(event.target.value);
  };

  const changesortIndex = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSortIndex(Number(event.target.value));
  };

  function changeCityIds(id: any, value: any) {
    setCityIds(id);
    setCity(value);
  }
  function changeIbanIds(id: any, value: any) {
    setIbanIds(id);
    setIban(value);
  }
  function changeStoreIds(id: any, value: any) {
    setStoreIds(id);
    setStore(value);
  }

  const handleChangePhoneNumber = (e: any) => {
    const char = e.target.value.match(/.{1,2}/g);
    setPhoneNumber(e.target.value);
    if (char && char[0] !== "09") {
      setPhoneNumber(e.target.value);
    } else {
      setPhoneNumber("0");
    }
  };

  const handleAddPhone = (phone: string) => {
    setPhoneNumbers((prev) => [...prev, phone]);
  };

  const handleDeletePhone = (phone: string) => {
    setPhoneNumbers((prev) => prev.filter((item) => item !== phone));
  };
  const request = {} as IBranchRequest;
  const handleRegisterOrUpdate = () => {
    request.ibanId = ibanIds!;
    request.phoneNumbers = phoneNumbers!;
    request.sortIndex = Number(sortIndex!);
    request.storeId = storeIds!;
    request.title = branchName!;
    request.type = selectedValue!;

    request.isActive = branchIsActive;
    if (selectedValue == "Onsite") {
      request.address = address;
      request.cityId = cityIds!;
      request.lat = mapPoint[0]!;
      request.lng = mapPoint[1]!;
    } else {
      request.url = siteAddress;
    }
    if (branchId) {
      request.id = Number(branchId);
      BranchUpdateMutate(request);
    } else {
      BranchAddMutate(request);
    }
  };
  const handleDeleteBranch = () => {
    BranchDeleteMutate({ id: Number(branchId!) });
  };
  if (isLoading) {
    return <BranchRegisterSkeleton />;
  }
  const isBtnDisabled =
    !storeIds ||
    !branchName ||
    !sortIndex ||
    // !ibanIds ||
    phoneNumbers.length === 0 ||
    (selectedValue === "Onsite" && (!cityIds || !address || !mapPoint)) ||
    (selectedValue === "Online" && !siteAddress);
  return (
    <>
      <Grid container spacing={3} sx={{ padding: "15px 30px" }}>
        <Grid item xs={12} md={6} container>
          <Grid item xs={12} sx={{ marginBottom: "16px" }}>
            <AutoCompleteSingleSearch
              name={`store`}
              id={`store`}
              label='*فروشگاه'
              value={storeIds}
              options={stores}
              onChange={changeStoreIds}
              responseValue={store}
              disabled={!!storeIdCache}
            />
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: "16px" }} container>
            <Grid xs={6} alignItems={"center"} style={{ marginTop: "3px" }}>
              <span style={{ marginTop: "2px", display: "inline-block" }}>
                نوع شعبه
              </span>
              <FormControl
                sx={{
                  direction: "rtl",
                  textAlign: "right",
                }}
              >
                <RadioGroup
                  row
                  aria-labelledby='demo-radio-buttons-group-label'
                  name='radio-buttons-group'
                  value={selectedValue}
                  onChange={handleChangeRadioBtn}
                >
                  <FormControlLabel
                    value={"Online"}
                    control={
                      <Radio
                        sx={{
                          color: "#1565C0",
                          padding: "2px !important",
                          "&.Mui-checked": {
                            color: "#1565C0",
                          },
                        }}
                      />
                    }
                    label={"آنلاین"}
                    sx={{ marginRight: 2 }}
                  />
                  <FormControlLabel
                    value={"Onsite"}
                    control={
                      <Radio
                        sx={{
                          color: "#1565C0",
                          padding: "2px !important",
                          "&.Mui-checked": {
                            color: "#1565C0",
                          },
                        }}
                      />
                    }
                    label={"حضوری"}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid xs={6} textAlign='right'>
              <CustomizeSwitch
                Label={"وضعیت شعبه"}
                //   checked={values.isActive || false} //{isActive}
                checked={branchIsActive}
                onChange={(checked: boolean) => {
                  setBranchIsAvitve(checked);
                }}
                onlabel={"فعال"}
                offlabel={"غیرفعال"}
              />
            </Grid>
          </Grid>

          {/* فیلدهای عمومی */}
          <Grid
            item
            xs={12}
            container
            spacing={2}
            sx={{ marginBottom: "14px" }}
          >
            <Grid item xs={8}>
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"عنوان شعبه"}
                label={"*عنوان شعبه"}
                required={false}
                value={branchName}
                onChange={changeBranchName}
                name='branchName'
                id='branchName'
              />
            </Grid>
            <Grid item xs={4}>
              <MaterialTextFieldComponent
                helperText={""}
                placeHolder={"ترتیب نمایش"}
                label={"*ترتیب نمایش"}
                required={false}
                value={sortIndex}
                onChange={changesortIndex}
                name='sortIndex'
                id='sortIndex'
                type='number'
                inputProps={{ min: 1 }}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} sx={{ marginBottom: "24px" }}>
            <AutoCompleteSingleSearch
              name={`iban`}
              id={`iban`}
              label='انتخاب شماره شبا'
              value={ibanIds}
              options={ibans}
              onChange={changeIbanIds}
              responseValue={iban}
            />
          </Grid>

          <Grid item xs={12} sx={{ marginBottom: "20px" }}>
            <CacheProvider value={cacheRtl}>
              <ThemeProvider theme={theme}>
                <div dir='rtl'>
                  <TextFieldBadge
                    value={phoneNumbers}
                    onAdd={handleAddPhone}
                    onDelete={handleDeletePhone}
                    label='*شماره تماس'
                  />
                </div>
              </ThemeProvider>
            </CacheProvider>
            {/* <TextFeildBadge
    // className={"shadowTextField"}
    // id="phoneNumber"
    // name="phoneNumber"
    // label={"*شماره تلفن"}
    // value={phoneNumber || ""}
    // placeHolder={"021-00000000"}
    // onChange={handleChangePhoneNumber}
    /> */}
          </Grid>

          {/* فیلدهای وابسته به نوع شعبه */}
          {selectedValue === "Onsite" && (
            <>
              <Grid item xs={12} sx={{ marginBottom: "20px" }}>
                <AutoCompleteSingleSearch
                  label={"*استان و شهر محل فعالیت"}
                  name={`city`}
                  id={`city`}
                  value={cityIds}
                  options={cities}
                  onChange={changeCityIds}
                  responseValue={city}
                />
              </Grid>
              <Grid item xs={12} sx={{ marginBottom: "16px" }}>
                <MaterialTextFieldComponent
                  multiline
                  helperText={""}
                  placeHolder={"آدرس"}
                  label={"*آدرس"}
                  required={false}
                  value={address}
                  onChange={changeAddress}
                  name='address'
                  id='address'
                  rows={3}
                  sx={{
                    "& .MuiOutlinedInput-root > .MuiInputBase-input ": {
                      fontSize: 13,
                      lineHeight: "2vh !important",
                    },

                    "& .MuiInputBase-root": {
                      height: "15vh !important",
                      alignItems: "start",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "0px !important",
                    },
                  }}
                />
                <br />
              </Grid>
            </>
          )}
          {selectedValue === "Online" && (
            <Grid item xs={12} sx={{ marginBottom: "16px" }}>
              {/* <MaterialTextFieldComponent */}
              <WebsiteInput
                // helperText={""}
                placeHolder={"www.address.com"}
                label={"*آدرس سایت"}
                // required={false}
                value={siteAddress}
                onChange={changeSiteAddress}
                name='siteAddress'
                id='siteAddress'
              />
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          {selectedValue === "Onsite" && (
            <MapPint setMapPoint={setMapPoint} mapPoint={mapPoint} />
          )}
        </Grid>
        <Grid
          item
          container
          xs={12}
          sx={{ display: "flex", justifyContent: "end" }}
        >
          {branchId && (
            <Grid item xs={12} sm={12} md={1} marginTop='8px' marginRight='7px'>
              <Button
                variant='contained'
                style={{
                  fontSize: "1rem",
                  color: "#fff",
                  height: "40px",
                  background: "#E6123D",
                  padding: "10px",
                  borderRadius: "4px",
                  width: "100%",
                }}
                onClick={() => setOpenModal(true)}
              >
                حذف شعبه
              </Button>
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={1} marginTop='8px' marginRight='7px'>
            <Button
              variant='contained'
              style={{
                fontSize: "1rem",
                color: "#fff",
                height: "40px",
                borderRadius: "4px",
                padding: "10px",
                width: "100%",
              }}
              className={`
              ${
                isBtnDisabled
                  ? // props.errors Object.keys(props.errors).length > 0
                    "btnForm disabledBtn  "
                  : "btnForm SuccessDefault"
              }`}
              onClick={handleRegisterOrUpdate}
              disabled={isBtnDisabled}
            >
              {"ثبت"}
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={1} marginTop='8px' marginRight='7px'>
            <Button
              variant='contained'
              style={{
                fontSize: "1rem",
                color: "#fff",
                height: "40px",
                background: "#607D8B",
                borderRadius: "4px",
                padding: "20px",
                width: "100%",
              }}
              onClick={() => {
                if (backUrl === "store") {
                  history.push("/store/StoreDetail");
                } else {
                  history.push("/store/BranchesTable");
                }
              }}
            >
              بازگشت
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <ModalCancel
        title={""}
        bgColor={"kamanColor"}
        setValue={handleDeleteBranch}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </>
  );
};
